import React, { useContext, useEffect, useState } from "react";
 import Box from '@mui/material/Box';
 import { useNavigate } from "react-router-dom";
 import { FormControl, FormHelperText, Input, InputLabel, MenuItem, Select } from "@mui/material";
 import { ToastContainer, toast } from 'react-toastify';
import axios  from "axios";
import "../../styles/profile.css";

const ChangePwdForm = (props) => {
     let basicUserInfo2 = localStorage.getItem("activeUser");
    basicUserInfo2 = (basicUserInfo2) ? JSON.parse(basicUserInfo2) : [];
    const handleClose = props.handleClose;

    const [currentUserRole, setCurrentUserRole] = useState(basicUserInfo2); 
     const navigate = useNavigate();

 
    const [password, setPassword] = useState("");
    const [cpassword, setCPassword] = useState("");

    const [passwordErr, setPasswordErr] = useState(false);
     const [cpasswordErr, setCPasswordErr] = useState(false);
         const sendRequest = async () => {
            setPasswordErr(false);
            setPasswordErr(false);
        
        if (password != "" && cpassword != "" && password == cpassword && password.length >= 6 && cpassword.length >= 6) {
            let formData = {
                password: password
                };

                axios.post(process.env.REACT_APP_API_BASE_URL+"UpdateProfile/"+basicUserInfo2.id, { ...formData })
                    .then((res) => {
                          if(res.data.status === true){
                          toast.success('Password changed sucessfully!!');
                             handleClose();
                          setTimeout(() => {
                            navigate('/'+basicUserInfo2.user_type+'/profile');
                          }, 1000);
                      }
                      else{
                          toast.success("something went wrong...")
                      }
                    })
                    .catch(err => {
                      console.error(err);
                      toast.error(err);
                    }); 

        } else {
          

            if (password == "" || password.length < 6) {
                setPasswordErr(true);
            }
            
            if (cpassword == "" || cpassword.length < 6) {
                setCPasswordErr(true);
            }
            if (password.length>=6 && password.length>=6 && password != cpassword){
               setCPasswordErr(true);
               toast.error("Confirm password must be same as password");   
            } 
        }
    };
  
 

    return (
        <Box sx={{ p: 2.5, pb: 0 }}>
            <ToastContainer></ToastContainer>
                   
            <div className="  register   pt-3">
                <h4 > Profile Update</h4>
                <div className="register__container p-5">

                    <div className="container row">
 
                        <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12">

                            <FormControl fullWidth>
                                <InputLabel htmlFor="my-input">Password</InputLabel>
                                <Input
                                    error={passwordErr}
                                    aria-describedby="my-helper-text"
                                    type="text"
                                    onChange={(e) => {
                                        setPassword(e.target.value);
                                        let pinc = e.target.value;
                                          if (!pinc ||  pinc.length < 6) {
                                            setPasswordErr(true);
                                        } else {
                                            setPasswordErr(false);
                                        }
                                    }}
                                    name="password"
                                    value={password}
                                    required
                                />, 
                                {passwordErr && (
                                    <FormHelperText id="my-helper-text" error={true}>
                                        Please enter valid Password(min 6 characters long).
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </div>
                        <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12">

<FormControl fullWidth>
    <InputLabel htmlFor="my-input">Confirm Password</InputLabel>
    <Input
        error={cpasswordErr}
        aria-describedby="my-helper-text"
        type="text"
        onChange={(e) => {
            setCPassword(e.target.value);
            let pinc = e.target.value;
              if (!pinc ||  pinc.length < 6) {
                setCPasswordErr(true);
            } else {
                setCPasswordErr(false);
            }
        }}
        name="cpassword"
        value={cpassword}
        required
    />, 
    {cpasswordErr && (
        <FormHelperText id="my-helper-text" error={true}>
            Please enter valid Password(min 6 characters long).
        </FormHelperText>
    )}
</FormControl>
</div>
                        <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12">

                            <button className="register__btn btn btn-primary float-right mt-3" onClick={sendRequest}>
                                Save
                            </button>


                        </div>
                    </div>
                </div>
            </div>

        </Box>
    )
}

export default ChangePwdForm